module.exports = __webpack_public_path__ + "static/media/30.3ed3cbd4.jpeg";